export default __webpack_public_path__ + "static/media/Sand.afb8a587.jpg";